import { ContactListFilters } from '@models/ApproveitAccounting'

// Pure helper extracted from index.ts so it's reachable from vitest without
// pulling in the axios + Routes module graph that the query hooks depend on.
//
// Serializes filters into the comma-separated multi-value shape the backend
// expects. Empty arrays / blanks are stripped so the URL stays clean — also
// so the react-query cache key doesn't churn on empty-vs-undefined diffs.
export const buildContactsFilterParams = (filters: ContactListFilters | undefined): Record<string, string> => {
  if (!filters) return {}
  const out: Record<string, string> = {}
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    if (Array.isArray(value)) {
      const joined = value.filter(Boolean).join(',')
      if (joined) out[key] = joined
    } else {
      out[key] = String(value)
    }
  })
  return out
}
